import {
  List,
  Datagrid,
  ReferenceField,
  ChipField,
  TextField,
  DateField,
  SearchInput,
  ReferenceInput,
  SelectInput,
  TextInput,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const PurchaseList = ({ isEdit, isDelete }) => (
  <List
    filters={[
      <SearchInput source="search" alwaysOn />,
      <ReferenceInput source="userId" reference="users" />,
      <ReferenceInput source="productId" reference="products" />,
      <SelectInput
        source="platform"
        choices={[
          { id: 'ios', name: 'ios' },
          { id: 'android', name: 'android' },
        ]}
      />,
      <TextInput source="search" />,
    ]}
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField source="userId" reference="users" />
      <ReferenceField source="productId" reference="products" />
      <ChipField source="platform" />
      <TextField source="receiptKey" />
      <ReferenceField source="orderId" reference="orders" />
      <TextField source="rawReceipt" />
      <DateField source="purchasedAt" />
    </Datagrid>
  </List>
)

export const PurchaseShow = () => (
  <Show>
    <SimpleShowLayout>
      <ReferenceField source="userId" reference="users" />
      <ReferenceField source="productId" reference="products" />
      <ChipField source="platform" />
      <TextField source="receiptKey" />
      <ReferenceField source="orderId" reference="orders" />
      <TextField source="rawReceipt" />
      <DateField source="purchasedAt" />
    </SimpleShowLayout>
  </Show>
)
